// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/utils/strings.ts"
);
import.meta.hot.lastModified = "1771756423361.2559";
}
// REMIX HMR END

export function convertUnicodeToChar(text: string): string {
    let result = '';
    let escapeSequence = '';

    for (let i = 0; i < text.length; i++) {
        const char = text[i];

        if (escapeSequence.length === 0 && char === '\\') {
            escapeSequence += char;
        } else if (escapeSequence.length === 1 && char === 'u') {
            escapeSequence += char;
        } else if (escapeSequence.length === 2) {
            escapeSequence += char;
            if (i + 3 < text.length && /^[0-9a-fA-F]{3}$/.test(text.substring(i + 1, i + 4))) {
                escapeSequence += text[i + 1] + text[i + 2] + text[i + 3];
                const codePoint = parseInt(escapeSequence.substring(2), 16);
                result += String.fromCharCode(codePoint);
                i += 3;
            } else {
                result += escapeSequence + char;
                escapeSequence = '';
            }
        } else {
            result += char;
            escapeSequence = '';
        }
    }

    return result;
}


export function insertSubstringAfterTrigger(string: string, triggerKeyword: string, substring: string): string {
    const triggerIndex = string.indexOf(triggerKeyword);

    if (triggerIndex === -1) {
        return string;
    }

    return string.slice(0, triggerIndex + triggerKeyword.length) + substring + string.slice(triggerIndex + triggerKeyword.length);
}


export function formatDateShort(dateString: string, locale: string = 'de-CH'): string {
    try {
        const date = new Date(dateString);
        const formatter = new Intl.DateTimeFormat(locale, { timeZone: 'Europe/Zurich' });
        return formatter.format(date);
    } catch {
        return dateString
    }
}



export function removeTrailingSlash(str: string): string {
    return str.endsWith("/") ? str.slice(0, -1) : str;
}



export function replaceMarkdownLinksWithHTML(text: string): string {
    const regex = /\[(http|https):\/\/([^/]+)(\/[^\]]*)?\]\s*\(([^)]+)\)/g;

    return text.replace(regex, '<a href="$1://$2$3" class="a_1">$4</a>');
}

function replaceUrlsWithLinks(text: string): string {
    const urlRegex = /\[(https?:\/\/[^\s\]]+)\]/g;
    return text.replace(urlRegex, (match, url: string) => {
      const hostname = new URL(url).hostname;
      return `<a  href="${url.trim().toString()}" class="a_1">${hostname.trim()}</a>`;
    });
  }
  


export function replaceUnformatedLinksForInnerHtml(text: string): string {
    const step1 = replaceMarkdownLinksWithHTML(text)
    const step2 = replaceUrlsWithLinks(step1)
    return step2.trim()
}



export function timeNoDate(timeString:string) {
    const [hour, minute] = timeString.split(/[-T:]/).slice(3, 5)
    return `${hour}:${minute.padStart(2, '0')}`
}


export function extractUrl(text: string): string | null {
    const urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;
    const match = urlRegex.exec(text);
  
    if (match) {
      return match[0];
    } else {
      return null;
    }
  }


export  function cropMetadescriptionFromText(sentence: string): string {
    if (sentence.length <= 150) {
      return sentence;
    }
  
    const fullStopIndex = sentence.indexOf('.', 150);

    if (fullStopIndex !== -1 && fullStopIndex <= 250) {
      return sentence.substring(0, fullStopIndex + 1);
    }
  
    return sentence.substring(0, 250);
  }


  /*
  export function replaceATagsWithHref(htmlString: string): string {
    const regex = /<a([^>]+)href="([^"]+)"([^>]*?)>(.*?)<\/a>/g; // Capture groups for flexibility
  
    return htmlString.replace(regex, (match, attributes, href, rest, innerText) => {
      // Decode encoded characters
      const decodedInnerText = innerText.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
  
      // Optionally process attributes (if needed)
      // let processedAttributes = attributes;  // Uncomment for attribute processing
  
      return href + (innerText ? ` (${decodedInnerText})` : ''); // Add inner text in parentheses
      // return href + (processedAttributes ? ` [${processedAttributes}]` : '') + (innerText ? ` (${decodedInnerText})` : '');  // For including attributes
    });
  }


export  function convertEncodedLinkToHTML(encodedLink: string) {
    // Decode special characters (replace &lt; with < and &gt; with >)
    const decodedLink = encodedLink
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>');
  
    // Extract URL and inner text using regular expression
    const regex = /href="([^"]+)"[^>]*>(.*?)<\/a>/;
    const match = regex.exec(decodedLink);
  
    if (match) {
      const url = match[1];
      const innerText = match[2];
      return `<a href="${url}" target="_blank">${innerText}</a>`; // Return the HTML a tag
    } else {
      return encodedLink; // Return the original string if no match is found
    }
  }

  */


 export function convertEncodedHtmlToHtml(encodedHtml:string) {
    // Ersetze alle HTML-Entitäten, einschließlich Zeilenumbrüche (&#xD;)
    const decodedHtml = encodedHtml.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#xD;/g, '\n');

    // Finde alle <a>-Tags mit href-Attribut und ersetze sie durch HTML-Elemente
    const regex = /<a href="([^"]+)"\s+target="_blank">([^<]+)<\/a>/g;
    return decodedHtml.replace(regex, '<a class="a_1" href="$1" target="_blank" rel="noopener noreferrer">$2</a>');
}